<template>
  <div>
    <b-row>
      <b-col>
        <!-- Object Details Row --->
        <b-row>
          <b-col>
            <b-card no-body>
              <b-card-header class="border-bottom">
                <h4 class="mb-0">
                  Object Details
                </h4>
                <b-card-text>
                  <b-button
                    variant="outline-primary"
                    @click="$refs.editObjectModal.show()"
                  >Edit</b-button>
                </b-card-text>
              </b-card-header>
              <b-card-body>
                <b-row class="mb-2 mt-2">
                  <b-col>
                    <p><b>ID:</b></p>
                    <kbd>{{ object.id }}</kbd>
                  </b-col>

                  <b-col>
                    <p> <b>Name</b></p>
                    <kbd>{{ object.name }}</kbd>
                  </b-col>

                  <b-col>
                    <p> <b>Serial Number</b></p>
                    <kbd>{{ object.manufacturerSerialNumber }}</kbd>
                  </b-col>
                </b-row>

                <b-row class="border-bottom mb-2">
                  <b-col>
                    <h4>Manufacturer & Model</h4>
                  </b-col>
                </b-row>

                <b-row class="mb-2 mt-2">
                  <b-col>
                    <p>
                      <b>Manufacturer</b>
                    </p>
                    <kbd> {{ object.manufacturer }}</kbd>
                  </b-col>

                  <b-col>
                    <p>
                      <b>Model</b>
                    </p>
                    <kbd>
                      {{ object.model }}
                    </kbd>
                  </b-col>

                  <b-col>
                    <p>
                      <b>Model Number</b>
                    </p>
                    <kbd>
                      {{ object.modelNumber }}
                    </kbd>
                  </b-col>
                </b-row>

                <b-row class="border-bottom mb-2">
                  <b-col>
                    <h4>Site</h4>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col>
                    <div
                      v-if="object.site"
                    >
                      <b-button
                        size="sm"
                        pill
                        variant="warning"
                        @click="$router.push(`/site/${object.site.id}`)"
                      >
                        {{ object.site.name }}
                      </b-button>
                    </div>
                    <div
                      v-else
                    >
                      No Site
                    </div>
                  </b-col>

                </b-row>

              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-modal
      id="editObjectModal"
      ref="editObjectModal"
      title="Edit Object"
      size="lg"
      ok-title="Save"
      cancel-variant="outline-primary"
      @ok="$emit('saveObjectDetails', object)"
    >
      <b-row class="border-bottom mb-2">
        <b-col>
          <h4>
            Object Details
          </h4>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            label="Name"
            label-for="name"
          >
            <b-form-input
              id="name"
              v-model="object.name"
              required
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="Serial Number"
            label-for="serialNumber"
          >
            <b-form-input
              id="serialNumber"
              v-model="object.manufacturerSerialNumber"
              required
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            label="Manufacturer"
            label-for="manufacturer"
          >
            <b-form-input
              id="manufacturer"
              v-model="object.manufacturer"
              required
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="Model"
            label-for="model"
          >
            <b-form-input
              id="model"
              v-model="object.model"
              required
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="Model Number"
            label-for="modelNumber"
          >
            <b-form-input
              id="modelNumber"
              v-model="object.modelNumber"
              required
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="border-bottom mb-2">
        <b-col>
          <h4>
            Site
          </h4>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            label="Site"
            label-for="site"
          >
            <v-select
              id="site"
              v-model="object.site"
              :options="sites"
              label="name"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>

  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardText,
  BCardBody,
  BButton,
  BFormInput,
  BFormGroup,
  BModal,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BCardHeader,
    BCardText,
    BButton,
    BCardBody,
    BFormInput,
    BFormGroup,
    BModal,
    vSelect,
  },
  props: {
    object: {
      type: Object,
      required: true,
    },
    devices: {
      type: Array,
      required: true,
    },
    sites: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
